var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0962 18.2554L12 19.2126L10.9038 18.2554C6.98842 14.8366 5 11.8112 5 9C5 5.02141 8.10349 2 12 2C15.8965 2 19 5.02141 19 9C19 11.8112 17.0116 14.8366 13.0962 18.2554ZM5.68555 14.8034C6.09614 15.3656 6.55352 15.9373 7.05748 16.519C5.19525 16.9384 4 17.5337 4 18C4 18.807 7.57914 20 12 20C16.4209 20 20 18.807 20 18C20 17.5337 18.8047 16.9384 16.9425 16.519C17.4465 15.9373 17.9039 15.3656 18.3144 14.8034C20.5633 15.4858 22 16.5804 22 18C22 20.5068 17.5203 22 12 22C6.47973 22 2 20.5068 2 18C2 16.5804 3.43674 15.4858 5.68555 14.8034ZM12 4C14.8038 4 17 6.13816 17 9C17 11.047 15.3727 13.5659 12 16.556C8.62733 13.5659 7 11.047 7 9C7 6.13816 9.19624 4 12 4ZM12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6ZM11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9Z",
    fill: "url(#paint0_linear_8915_12515)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8915_12515",
    x1: -9.5,
    y1: 1.58152,
    x2: -9.5,
    y2: 18.4952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRound);
export default __webpack_public_path__ + "static/media/pin-round.1688c636.svg";
export { ForwardRef as ReactComponent };